<template>
    <el-table
        ref="moduleTable"
        class="table-content"
        :data="tableData"
        :max-height="300"
        border
    >
        <el-table-column
            show-overflow-tooltip
            v-for="(item, index) in columnsList"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
        >
        </el-table-column>
    </el-table>
</template>
<script>
import { columnsList } from './tableContentConfig';

export default {
    props: {
        contentTableData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            columnsList,
            tableData: []
        };
    },
    created () {
        this.getData(this.contentTableData);
    },
    methods: {
        // 获取数据
        getData (tableData) {
            this.tableData = tableData.responseList || [];
        }
    }
};
</script>
<style lang="less">

</style>
